import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories, brandInfo } from '@/mocks/site';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-xl font-bold ${isScrolled ? 'text-foreground-950' : 'text-white'}`}>
              🔥 {brandInfo.name}
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/' ? (isScrolled ? 'text-primary-600' : 'text-white font-bold') : (isScrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/80 hover:text-white')
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors ${
                  location.pathname === `/category/${cat.slug}` ? (isScrolled ? 'text-primary-600' : 'text-white font-bold') : (isScrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/80 hover:text-white')
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/about' ? (isScrolled ? 'text-primary-600' : 'text-white font-bold') : (isScrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/80 hover:text-white')
              }`}
            >
              关于我们
            </Link>
            <a
              href="#subscribe"
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all ${
                isScrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-primary-600 hover:bg-white/90'
              }`}
            >
              订阅爆料
            </a>
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl ${isScrolled ? 'text-foreground-950' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-800 py-2 whitespace-nowrap" onClick={() => setIsMobileMenuOpen(false)}>首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm font-medium text-foreground-800 py-2 whitespace-nowrap" onClick={() => setIsMobileMenuOpen(false)}>{cat.name}</Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-800 py-2 whitespace-nowrap" onClick={() => setIsMobileMenuOpen(false)}>关于我们</Link>
            <a href="#subscribe" className="text-center px-5 py-2 rounded-full text-sm font-semibold bg-primary-500 text-white whitespace-nowrap" onClick={() => setIsMobileMenuOpen(false)}>订阅爆料</a>
          </div>
        </div>
      )}
    </nav>
  );
}